import { apiGET } from './api';

export const getRescueSizes = () => apiGET('/rescue_sizes');
